<div class="row match-panel-heights auto-width">
    <div class="col-md-5 col-sm-5">
        <form #clientForm="ngForm">
            <div class="panel panel-white">
                <div class="panel-heading border-light">
                    <h4 class="panel-title">Client Details</h4>
                    <ul class="panel-heading-tabs border-light">
                        <li>
                            <div class="btn-group">
                                <button
                                    type="button"
                                    class="btn btn-info"
                                    *ngIf="!editModes.customer && permissions.editCustomerDetails"
                                    (click)="showClientsForm(clientForm)"
                                    [disabled]="editModes.customer">
                                    <i class="ti-pencil"></i>
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-warning"
                                    *ngIf="editModes.customer"
                                    (click)="saveDetails()"
                                    [disabled]="!clientForm.valid">
                                    <i class="ti-check"></i>
                                    Save
                                </button>
                                <button type="button" class="btn btn-default" *ngIf="editModes.customer" (click)="cancelClientsForm()">
                                    <i class="ti-close"></i>
                                </button>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="panel-body">
                    <div class="form-group">
                        <label class="text-info fixed-label fixed-label-120">
                            <span *ngIf="editModes.customer" class="mandatory-field"></span> Name
                        </label>
                        <span *ngIf="!editModes.customer"
                            ><strong>{{ customer.Name }}</strong></span
                        >
                        <input
                            legacy-css
                            name="Name"
                            type="text"
                            placeholder="Name"
                            class="form-control"
                            maxlength="50"
                            *ngIf="editModes.customer"
                            [(ngModel)]="customer.Name"
                            required
                            (change)="checkCustomerNameUnique(clientForm)"
                            [ngModelOptions]="{}" />
                        <div class="alert alert-danger margin-top-5" *ngIf="exists">
                            This name already exists. Please enter a unique name.
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="text-info fixed-label fixed-label-120"> Created </label>
                        <span *ngIf="!editModes.customer">{{ customer.DateCreated | date }}</span>
                        <div class="form-group">
                            <div *ngIf="editModes.customer">
                                <!-- ngx-bootstrap 7.1.2 date picker - Clear button doesn't work, so setting it to false
                                     we'll wait for upgrade to version 8.0.0  -->
                                <input
                                    legacy-css
                                    bsDatepicker
                                    [bsConfig]="{
                                        adaptivePosition: true,
                                        showWeekNumbers: false,
                                        containerClass: 'theme-default',
                                        customTodayClass: 'bsdatepicker-today',
                                        dateInputFormat: locale,
                                        showTodayButton: true,
                                        todayPosition: 'right',
                                        showClearButton: false,
                                    }"
                                    autocomplete="off"
                                    type="text"
                                    class="form-control form-control-v2"
                                    [(ngModel)]="customer.DateCreated"
                                    id="dateCreated"
                                    name="DateCreated"
                                    #dateCreated="bsDatepicker" />
                            </div>
                        </div>
                    </div>
                    <div *ngIf="isSupplier" class="form-group">
                        <label class="text-info fixed-label fixed-label-120">
                            {{ SupplierExternalRefFieldName ? SupplierExternalRefFieldName : 'External Reference' }}
                        </label>
                        <span *ngIf="!editModes.customer">{{ customer.ExternalRef }}</span>
                        <input
                            legacy-css
                            name="externalRef"
                            *ngIf="editModes.customer"
                            type="text"
                            [(ngModel)]="customer.ExternalRef"
                            class="form-control" />
                    </div>
                    <div *ngIf="isSupplier && SupplierExternalRefRequired2" class="form-group">
                        <label class="text-info fixed-label fixed-label-120">
                            {{ SupplierExternalRefFieldName2 ? SupplierExternalRefFieldName2 : 'External Reference 2' }}
                        </label>
                        <span *ngIf="!editModes.customer">{{ customer.ExternalRef2 }}</span>
                        <input
                            legacy-css
                            name="externalRef2"
                            *ngIf="editModes.customer"
                            type="text"
                            [(ngModel)]="customer.ExternalRef2"
                            class="form-control" />
                    </div>
                    <div class="form-group">
                        <label class="text-info fixed-label fixed-label-120"
                            ><span *ngIf="editModes.customer" class="mandatory-field"></span> Source
                        </label>
                        <span *ngIf="!editModes.customer">{{ customer.Source }}</span>
                        <input
                            legacy-css
                            *ngIf="editModes.customer"
                            name="Source"
                            type="text"
                            [(ngModel)]="customer.Source"
                            placeholder="Sources..."
                            [typeahead]="estimateSources"
                            [typeaheadMinLength]="0"
                            class="form-control form-control-v2"
                            maxlength="50" />
                    </div>
                    <div class="form-group">
                        <label class="text-info fixed-label fixed-label-120"> Address </label>
                        <a
                            *ngIf="!editModes.customer"
                            href="https://www.google.com/maps/place/{{ getEncodedAddress(customer.AddressFormatted) }}"
                            target="_blank"
                            >{{ customer.AddressFormatted }}</a
                        >
                        <app-bx-address-input
                            *ngIf="editModes.customer"
                            inputClass="form-control form-control-v2"
                            id="customerAddress"
                            [inputLegacyCss]="true"
                            inputMaxLength="200"
                            name="Address"
                            [(ngModel)]="customer.Address"
                            (onAddressSelected)="handleAddressChange($event)" />
                    </div>
                    <div *ngIf="editModes.customer">
                        <div class="form-group">
                            <label class="text-info" translate="general.address.city"></label>
                            <input
                                legacy-css
                                name="CityTown"
                                type="text"
                                translate-attr="{placeholder: 'general.address.city'}"
                                class="form-control"
                                [(ngModel)]="customer.CityTown"
                                maxlength="50" />
                        </div>
                        <div class="row">
                            <div class="col-xs-6">
                                <div class="form-group">
                                    <label translate="general.address.state"></label>
                                    <select legacy-css name="State" class="form-control" [(ngModel)]="customer.State">
                                        <option [value]="s.value" *ngFor="let s of sharedData.Common.StatesInfo">{{ s.value }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-xs-6">
                                <div class="form-group">
                                    <label translate="general.address.postcode"></label>
                                    <input
                                        legacy-css
                                        name="PostCode"
                                        type="text"
                                        translate-attr="{placeholder: 'general.address.postcode'}"
                                        class="form-control"
                                        [(ngModel)]="customer.PostCode"
                                        maxlength="10" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="text-info fixed-label fixed-label-120"> Phone </label>
                        <span *ngIf="!editModes.customer">{{ customer.Phone | phoneNumberLocalize }}</span>
                        <div class="form-group" *ngIf="editModes.customer">
                            <phone-number
                                name="phoneCustom"
                                [number]="customer.Phone"
                                [(ngModel)]="customer.Phone"
                                (parsednumber)="customer.Phone = $event"></phone-number>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="text-info fixed-label fixed-label-120" translate="general.address.mobile"></label>
                        <span *ngIf="!editModes.customer">{{ customer.Mobile | phoneNumberLocalize }}</span>
                        <div class="form-group" *ngIf="editModes.customer">
                            <phone-number
                                name="mobileCustom"
                                [number]="customer.Mobile"
                                [(ngModel)]="customer.Mobile"
                                (parsednumber)="customer.Mobile = $event"></phone-number>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="text-info fixed-label fixed-label-120"> Email </label>
                        <span *ngIf="!editModes.customer">{{ customer.Email }}</span>
                        <div class="form-group" *ngIf="editModes.customer">
                            <input
                                legacy-css
                                name="Email"
                                type="email"
                                email
                                placeholder="Email"
                                class="form-control"
                                [(ngModel)]="customer.Email"
                                maxlength="50" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="text-info width-130" translate="general.invoice.terms"> </label>
                        <span *ngIf="!editModes.customer">{{ customer.DefaultInvoiceDays }}</span>
                        <div class="form-group" *ngIf="editModes.customer">
                            <input
                                legacy-css
                                name="DefaultInvoiceDays"
                                type="number"
                                step="any"
                                translate-attr="{placeholder: 'general.invoice.terms'}"
                                class="form-control"
                                [(ngModel)]="customer.DefaultInvoiceDays" />
                        </div>
                    </div>
                    <div class="form-group" *ngIf="accountingProvider && accountingContacts?.length && accountingProvider === 'xero'">
                        <label class="text-info width-110 text-capitalize"> {{ accountingProvider }} Link </label>
                        <a class="pull-right" *ngIf="editModes.customer && getContactLink()" (click)="removeContactLink()">Unlink</a>
                        <span *ngIf="!editModes.customer">{{ getContactLink()?.description }}</span>
                        <ng-select
                            *ngIf="editModes.customer && accountingContacts.length"
                            class="light"
                            [items]="accountingContacts"
                            [clearable]="false"
                            [searchable]="true"
                            bindLabel="description"
                            bindValue="id"
                            [(ngModel)]="customer.AccountingId"
                            id="AccountingId"
                            name="AccountingId"
                            #accContacts="ngModel">
                        </ng-select>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="col-md-7 col-sm-7">
        <!--Contacts Panel-->
        <div class="panel panel-white" *ngIf="permissions.viewContacts">
            <div class="panel-heading border-light">
                <h4 class="panel-title">Contact Person</h4>
                <ul class="panel-heading-tabs border-light">
                    <li *ngIf="permissions.addContacts">
                        <div class="form-group">
                            <button type="button" class="btn btn-success" title="Create a contact person" (click)="addClient()">
                                <i class="ti-plus"></i>
                            </button>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="panel-body">
                <div class="col-xs-12 text-center" *ngIf="customer?.CustomerContacts?.length == 0 && permissions.addContacts">
                    <h2 class="margin-top-30 margin-bottom-30">
                        <a (click)="addClient()">Create a contact person from here</a>
                    </h2>
                </div>
                <app-client-details-list [client]="customer"></app-client-details-list>
            </div>
        </div>
    </div>
</div>

<div class="row match-panel-heights">
    <div class="col-sm-6">
        <!--Documents Panel-->
        <div *ngIf="permissions.viewDocuments">
            <app-bx-documents
                [reference]="customer.ID_Customer"
                [references]="documentsParams?.references"
                [sourceType]="clientSource"
                [hideAddButton]="!permissions.addDocuments"
                [hideTrashIcon]="!permissions.deleteDocuments">
            </app-bx-documents>
        </div>

        <div *ngIf="userType === 'Supplier'">
            <app-builder-statistics [clientId]="customer.ID_Customer">
                <h3 formHeading>Builder Statistics</h3>
            </app-builder-statistics>
        </div>
    </div>
    <div class="col-sm-6">
        <!--Notes Panel-->
        <app-notes
            [title]="'Notes'"
            [source]="'Clients'"
            [view]="permissions.viewNotes"
            [add]="permissions.addNotes"
            [delete]="permissions.deleteNotes"
            [referenceId]="customer.ID_Customer"
            [queryReferenceIds]="[customer.ID_Customer]">
        </app-notes>
    </div>
</div>
